import React from 'react';
import PropTypes from 'prop-types';
import EventDescription from '~shared/components/react/EventDescription/EventDescription';
import {
    useIsInplay,
    useHomeCompetitor,
    useAwayCompetitor,
    useIsStreamingAvailable,
    useMatchStatus,
    useStartTime,
} from '~SpectateStore/hooks/eventsHooks';
import { useTournamentLogosByEventId } from '~SpectateStore/hooks/tournamentsHooks';
import { useSportSlugByEventId } from '~SpectateStore/hooks/sportsHooks';
import {
    useIsUsFormat,
    useCategorySlugByEventId,
} from '~SpectateStore/hooks/categoriesHooks';
import { useScoreboardById } from '~SpectateStore/hooks/scoreboardHooks';
import ScoreboardFeedToggle from './ScoreboardFeedToggle';
import './styles/scoreboard.scss';

const ScoreboardSection = ({ eventId }) => {
    const isUsFormat = useIsUsFormat(eventId);
    const home = useHomeCompetitor(eventId);
    const away = useAwayCompetitor(eventId);
    const tournament_logos = useTournamentLogosByEventId(eventId);
    const inplay = useIsInplay(eventId);
    const is_streaming_available = useIsStreamingAvailable(eventId);
    const match_status = useMatchStatus(eventId);
    const sport_slug = useSportSlugByEventId(eventId);
    const category_slug = useCategorySlugByEventId(eventId);
    const extra_info = useScoreboardById(eventId);
    const start_time = useStartTime(eventId);

    return (
        <div className='scoreboard-section'>
            <EventDescription
                event={{
                    id: eventId,
                    isUsFormat,
                    competitors: {
                        home,
                        away,
                    },
                    tournament_logos,
                    inplay,
                    is_streaming_available,
                    match_status,
                    sport_slug,
                    category_slug,
                    extra_info,
                    start_time,
                }}
                isLink={false}
            />
            <ScoreboardFeedToggle
                eventId = {eventId}
            />
        </div>
    );
};

ScoreboardSection.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
};

export default ScoreboardSection;
